export default {
      id: "ic_raffle_arrow_down-usage",
      viewBox: "0 0 18 11",
      url: "/" + "images/icons.3.109.2.svg#ic_raffle_arrow_down-usage",
      toString: function () {
        return this.url;
      }
    }